import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./pages/App";
import { Loading } from "./pages/App/loading";
import Popup from "./pages/App/popup";
import Car from "./pages/Car";
import CarManage from "./pages/Car/CarManage";
import CarLanding from "./pages/CarLanding";
import CarLandingManage from "./pages/CarLanding/CarLandingManage";
import Dashboard from "./pages/Dashboard";
import DeliveryMethod from "./pages/DeliveryMethod";
import DeliveryMethodManage from "./pages/DeliveryMethod/DeliveryMethodManage";
import Landing from "./pages/Landing";
import LandingManage from "./pages/Landing/LandingManage";
import Merge from "./pages/Merge";
import Bijack from "./pages/Order/Bijack";
import Buy from "./pages/Order/Buy";
import Invoice from "./pages/Order/Print/Invoice";
import Label from "./pages/Order/Print/Label";
import Packing from "./pages/Order/Packing";
import PackingManage from "./pages/Order/Packing/Manage";
import Pricing from "./pages/Order/Pricing";
import PricingManage from "./pages/Order/Pricing/Manage";
import PartManage from "./pages/Part/PartManage";
import PaymentMethod from "./pages/PaymentMethod";
import PaymentMethodManage from "./pages/PaymentMethod/PaymentMethodManage";
import Specific from "./pages/Specific";
import SpecificManage from "./pages/Specific/SpecificManage";
import Part from "./pages/Part";
import AttributeValue from "./pages/AttributeValue";
import AddAttributeValue from "./pages/AttributeValue/AddAttributeValue";
import EditAttributeValue from "./pages/AttributeValue/EditAttributeValue";
import Brand from "./pages/Brand";
import BrandManage from "./pages/Brand/BrandManage";
import Category from "./pages/Category";
import CategoryManage from "./pages/Category/CategoryManage";
import Login from "./pages/Login";
import Menu from "./pages/Menu";
import MenuManage from "./pages/Menu/MenuManage";
import Orders from "./pages/Order";
import Bill from "./pages/Order/Bill";
import OrderManage from "./pages/Order/Manage";
import Product from "./pages/Product";
import ProductManage from "./pages/Product/Manage";
import PreProducts from "./pages/Product/PreProducts";
import Bulk from "./pages/Product/Bulk";
import Tag from "./pages/Tag";
import TagManage from "./pages/Tag/TagManage";
import UserManage from "./pages/User/UserManage";
import UsersList from "./pages/User";
import Variant from "./pages/Variant";
import VariantManage from "./pages/Variant/VariantManage";
import Year from "./pages/Year";
import AddYear from "./pages/Year/AddYear";
import EditYear from "./pages/Year/EditYear";
import reportWebVitals from "./reportWebVitals";
import store from "./services/store";
import Color from "./pages/Color";
import ColorManage from "./pages/Color/ColorManage";
import GuaranteeCompany from "./pages/GuaranteeCompany";
import GuaranteeCompanyManage from "./pages/GuaranteeCompany/GuaranteeCompanyManage";
import Page from "./pages/Page";
import PageManage from "./pages/Page/PageManage";
import HomePageManage from "./pages/Page/HomePageManage";
import Discount from "pages/Discount";
import DiscountManage from "pages/Discount/Manage";
import Setting from "pages/Setting";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <ThemeProvider>
    <Provider store={store}>
      <App />
      <BrowserRouter basename="/">
        <Routes>
          <Route path="Dashboard" element={<Dashboard />} />
          <Route path="login" element={<Login />} />
          <Route path="tag">
            <Route path="" element={<Tag />} />
            <Route path="add" element={<TagManage />} />
            <Route path="edit/:id" element={<TagManage />} />
          </Route>
          <Route path="bill">
            <Route path="" element={<Bill />} />
          </Route>
          <Route path="menu">
            <Route path="" element={<Menu />} />
            <Route path="add" element={<MenuManage />} />
            <Route path="edit/:id" element={<MenuManage />} />
          </Route>
          <Route path="car">
            <Route path="" element={<Car />} />
            <Route path="add" element={<CarManage />} />
            <Route path="edit/:id" element={<CarManage />} />
          </Route>
          <Route path="year">
            <Route path="" element={<Year />} />
            <Route path="add" element={<AddYear />} />
            <Route path="edit/:id" element={<EditYear />} />
          </Route>
          <Route path="brand">
            <Route path="" element={<Brand />} />
            <Route path="add" element={<BrandManage />} />
            <Route path="edit/:id" element={<BrandManage />} />
          </Route>
          <Route path="deliveryMethod">
            <Route path="" element={<DeliveryMethod />} />
            <Route path="add" element={<DeliveryMethodManage />} />
            <Route path="edit/:id" element={<DeliveryMethodManage />} />
          </Route>
          <Route path="paymentMethod">
            <Route path="" element={<PaymentMethod />} />
            <Route path="add" element={<PaymentMethodManage />} />
            <Route path="edit/:id" element={<PaymentMethodManage />} />
          </Route>
          <Route path="page">
            <Route path="" element={<Page />} />
            <Route path="add" element={<PageManage />} />
            <Route path="edit/:id" element={<PageManage />} />
            <Route path="home/:id" element={<HomePageManage />} />
          </Route>
          <Route path="color">
            <Route path="" element={<Color />} />
            <Route path="add" element={<ColorManage />} />
            <Route path="edit/:id" element={<ColorManage />} />
          </Route>
          <Route path="part">
            <Route path="" element={<Part />} />
            <Route path="add" element={<PartManage />} />
            <Route path="edit/:id" element={<PartManage />} />
          </Route>
          <Route path="attributeValue">
            <Route path="" element={<AttributeValue />} />
            <Route path="add" element={<AddAttributeValue />} />
            <Route path="edit/:id" element={<EditAttributeValue />} />
          </Route>
          <Route path="category">
            <Route path="" element={<Category />} />
            <Route path="add" element={<CategoryManage />} />
            <Route path="edit/:id" element={<CategoryManage />} />
          </Route>
          <Route path="merge" element={<Merge />} />
          <Route path="order">
            <Route path="" element={<Orders />} />
            <Route path="add" element={<OrderManage />} />
            <Route path="buy" element={<Buy />} />
            <Route path="edit/:id" element={<OrderManage />} />
            <Route path="bijack/:id" element={<Bijack />} />
            <Route path="label/:id" element={<Label />} />
            <Route path="invoice/:id" element={<Invoice />} />
            <Route path="pricing">
              <Route path="" element={<Pricing />} />
              <Route path="edit/:id" element={<PricingManage />} />
              <Route path="copy/:id" element={<PricingManage />} />
            </Route>
            <Route path="variant">
              <Route path="" element={<Variant />} />
              <Route path="add" element={<VariantManage />} />
              <Route path="edit/:id" element={<VariantManage />} />
            </Route>
            <Route path="packing">
              <Route path="" element={<Packing />} />
              <Route path="add" element={<PackingManage />} />
              <Route path="edit/:id" element={<PackingManage />} />
            </Route>
          </Route>
          <Route path="specific">
            <Route path="" element={<Specific />} />
            <Route path="add" element={<SpecificManage />} />
            <Route path="edit/:id" element={<SpecificManage />} />
          </Route>
          <Route path="product">
            <Route path="" element={<Product />} />
            <Route path="add/:id?" element={<ProductManage />} />
            <Route path="pre" element={<PreProducts />} />
            <Route path="bulk" element={<Bulk />} />
            <Route path="edit/:id" element={<ProductManage />} />
          </Route>
          <Route path="setting" element={<Setting />} />
          <Route path="discount">
            <Route path="" element={<Discount />} />
            <Route path="add" element={<DiscountManage />} />
            <Route path="edit/:id" element={<DiscountManage />} />
          </Route>
          <Route path="user">
            <Route path="" element={<UsersList />} />
            <Route path="add" element={<UserManage />} />
            <Route path="edit/:id" element={<UserManage />} />
          </Route>
          <Route path="landing">
            <Route path="" element={<Landing />} />
            <Route path="add" element={<LandingManage />} />
            <Route path="edit/:id" element={<LandingManage />} />
          </Route>
          <Route path="carLanding">
            <Route path="" element={<CarLanding />} />
            <Route path="add" element={<CarLandingManage />} />
            <Route path="edit/:id" element={<CarLandingManage />} />
          </Route>
          <Route path="guaranteeCompany">
            <Route path="" element={<GuaranteeCompany />} />
            <Route path="add" element={<GuaranteeCompanyManage />} />
            <Route path="edit/:id" element={<GuaranteeCompanyManage />} />
          </Route>
        </Routes>
        <Popup />
        <Loading />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
);

reportWebVitals();
